import { render, staticRenderFns } from "./qucheinfo.vue?vue&type=template&id=ac3050b6"
import script from "./qucheinfo.vue?vue&type=script&lang=js"
export * from "./qucheinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports